import plugin from './src/keep-aspect.plugin.js';
export default plugin;